export function firstDayOfMonth(date) {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${date.getFullYear()}-${month}-01`;
}

export function firstDayOfNextMonth(date) {
  return firstDayOfMonth(new Date(date.getFullYear(), date.getMonth() + 1, 1));
}
